import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ArrowComponent } from '@shared/arrow/arrow.component';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'companyid-business-goal-buttons',
    imports: [ArrowComponent, RouterLink],
    templateUrl: './business-goal-buttons.component.html',
    styleUrl: './business-goal-buttons.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessGoalButtonsComponent {}
